// extracted by mini-css-extract-plugin
export default {"sportsDataContainer":"sports_sportsDataContainer__VQNom"};